/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, replacePXinStringWithEM } from '@insticator/insticator-ui';



/* ++++++++++ --------------- COLOR CONFIG - SENTIMENT CONFIGS : STYLES --------------- ++++++++++ */
export default {
    colorconfig: {
        flex: '1',
        marginRight: pxToEm(16), // matches top margin of section card
        '& .sectioncard': {
            minHeight: '100%',
            '& .colorpickercolumn': {
                padding: replacePXinStringWithEM('20px 48px'),
                '& .colorpicker': {
                    marginBottom: pxToEm(16)
                }

            }
        }
    }
};
